export default __webpack_public_path__ + "static/media/slide5.19d18bbc.jpg";